import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import profession from '../../Assets/Icons/profession.svg'
import income from '../../Assets/Icons/income.svg'
import date from '../../Assets/Icons/date.svg'
import stars from '../../Assets/Icons/star.svg'
import workLocation from '../../Assets/Icons/workLocation.svg'
import flawsIcon from '../../Assets/Icons/flaws.svg'
import { FaBan, FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import dummy from '../../Assets/Images/dummy.jpg.webp'
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { setAlert } from "../../Store/Theme/actions"
import { useTranslation } from "react-i18next"

const DownloadedProfilePage = () => {

    const [loading, setLoading] = useState(true)
    const [profileList, setProfileList] = useState([])
    const [allStars, setAllStars] = useState([])
    const [educationList, setEducationList] = useState([]);
    const [zodiacSigns, setZodiacSigns] = useState([])
    const [flaws, setFlaws] = useState([])
    const [fullEducations, setFullEducations] = useState([])
    const [status, setStatus] = useState([])
    const [occupation, setOccupation] = useState([])
    const [planActive, setPlanActive] = useState(false)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const lang = useSelector((state) => state.theme.language)
    const userDetails = useSelector((state) => state.auth.userDetails)
    const history = useHistory()

    useEffect(() => {
        try {
            setLoading(true)
            axios.all([API.get('/user/downloadedProfiles'),
            API.get('/common/getEducations'), API.get('/common/getZodiacSign'),
            API.get('/common/getAllFlaws'), API.get('/common/getStatusList'),
            API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then(axios.spread((userRes, eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
                setProfileList(userRes.data.data)
                setPlanActive(userDetails.planActive)
                setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
                setFullEducations(eduRes.data.data)
                setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
                setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
                setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
                setOccupation(occuRes.data.data)
                setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
                setLoading(false)
            }))
        } catch (err) {
            console.log(err)
        }
    }, [userDetails])

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };


    const getQualification = (value) => {
        return educationList.filter((x) => { return x.value === value })[0]?.text || ''
    }

    return (
        <motion.div className="w-full overflow-scroll h-full py-5 flex flex-col bg-primeColor/20 gap-2">
            {
                loading ? "Loading please wait..." : <motion.div className="flex flex-col overflow-scroll md:px-20 gap-2">
                    {profileList && profileList.length > 0 && profileList.map((c, i) => {
                        return (<motion.div key={i} className="flex flex-col rounded-lg bg-white gap-5">
                                    <motion.div className="py-5 px-2 sm:px-6 flex flex-col gap-5">
                                        <motion.div className="flex flex-col md:flex-row justify-start gap-5 ">
                                            <motion.div className="flex flex-col gap-2 relative w-[300px]">
                                                {(c?.previewUrls && c.previewUrls[0]) ? (
                                                    <img
                                                        src={(planActive || c.isDownloaded) ? c.previewUrls[0] : dummy}
                                                        className="w-[244px] h-[244px] sm:h-[244px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                ) : <img
                                                    src={dummy}
                                                    className="w-[244px] h-[244px] sm:h-[244px] md:h-[244px] object-center rounded-md"
                                                    alt="Preview"
                                                />}
                                            </motion.div>
                                            
                                            <motion.div className="flex flex-col w-full relative gap-1">
                                                {lang === 'en' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}
                                                    >
                                                        {c.firstName} ({c.surname})
                                                    </p>
                                                )}
                                                {lang === 'ta' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}
                                                    >
                                                        {c.tFirstName} ({c.tSurname})
                                                    </p>
                                                )}
                                                <p className="text-[gray] text-md font-bold">{c.refId}</p>
                                                <motion.div className="flex flex-row flex-wrap w-full items-center gap-1">
                                                    <p>{calculateAge(c.dateOfBirth)} {t('Yrs')}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <p>{c.heightInFeet || '-'}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? zodiacSigns.find(x => x.value === c.additionalInformation.zodiacSign)?.text : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? allStars.find(x => x.value === c.additionalInformation.star)?.text || '---' : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{c.educationalQualification.length > 0 ? c.educationalQualification.map(getQualification) : c.otherEducationalQualification || '--'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    {(planActive || c.isDownloaded) ? c.occupation !== 'undefined' && c.occupation.toString().trim().length ? c.occupation : 'Not working' : '----'}
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>)
                    })}

                </motion.div>
            }
        </motion.div >
    )
}

export default DownloadedProfilePage